import { computed, reactive } from "vue";

type Primitive = string | number | boolean | bigint | symbol | Primitive[];
type Options = Record<string, Primitive>;

const visibleDialogs = reactive<
  Record<string, { visible: boolean; options?: Options }>
>({});

export function useDialogs() {
  const isVisible = (id: string) => visibleDialogs[id]?.visible;

  const show = (id: string, options: Options) => {
    const value = visibleDialogs[id] ?? { visible: false };
    visibleDialogs[id] = { ...value, visible: true, options };
  };

  const hide = (id: string) => {
    const value = visibleDialogs[id] ?? { visible: false };
    visibleDialogs[id] = { ...value, visible: true, options: undefined };
  };

  return { isVisible, show, hide };
}

export function useDialog(id: string) {
  const visible = computed<boolean>(() => visibleDialogs[id]?.visible);
  const options = computed<Options | undefined>(
    () => visibleDialogs[id]?.options
  );

  const show = (options?: Options) => {
    const value = visibleDialogs[id] ?? { visible: false };
    visibleDialogs[id] = { ...value, visible: true, options };
  };
  const hide = () => {
    const value = visibleDialogs[id] ?? { visible: false };
    visibleDialogs[id] = { ...value, visible: false, options: undefined };
  };

  return { visible, options, show, hide };
}
